import router from "@/router";

let inactivityTimer = null;

const handleUserActivity = (store) => {
  resetInactivityTimer(store);
};

export const resetInactivityTimer = (store) => {
  clearTimeout(inactivityTimer);
  if (router.currentRoute.path !== "/"){
    if(store.state.authentication.logOutTime > 0){
        inactivityTimer = setTimeout(() => {
            store.dispatch("authentication/LOGOUT");
        }, store.state.authentication.logOutTime);
    }
  }
};

export const startTrackingInactivity = (store) => {
  if (router.currentRoute.path !== "/") {
    resetInactivityTimer(store);  
 
    window.removeEventListener("mousemove", () => handleUserActivity(store));
    window.removeEventListener("keydown", () => handleUserActivity(store));
    window.removeEventListener("click", () => handleUserActivity(store));
 
    window.addEventListener("mousemove", () => handleUserActivity(store));
    window.addEventListener("keydown", () => handleUserActivity(store));
    window.addEventListener("click", () => handleUserActivity(store));
  }
};

